import SpriteSymbol from "../../../../../../svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "unreachable",
  "use": "unreachable-usage",
  "viewBox": "0 0 12 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 14\" id=\"unreachable\"><path d=\"M10 8.5H8V10H5.62l-1.38 1.5h.96v2h1.62v-2H9.5V10h2V3.62L10 5.24V8.5zM11.5.45a.746.746 0 00-1.06.05l-.46.5H.5v9h1.3L.44 11.5c-.28.31-.26.78.05 1.06.14.13.32.2.5.2.2 0 .41-.08.55-.25l10-11c.29-.31.27-.79-.04-1.06zM3.17 8.5H2v-6h1.25V4h1.5V2.5h3.87l-5.45 6z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol